var _defs, _g, _g2, _g3, _rect, _path, _rect2, _rect3, _rect4, _rect5, _path2, _rect6, _rect7, _path3, _rect8, _rect9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStandaloneForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 300,
    viewBox: "0 0 132.29 79.375",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "upload-b-grad",
    className: "upload-b-grad",
    x1: 7.2876,
    x2: 16.084,
    y1: 166.63,
    y2: 166.63,
    gradientTransform: "matrix(3.5943 0 0 .27822 5.9759 14.167)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "upload-b-fill",
    stopColor: "#392781",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    className: "upload-b-fill",
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.99172 0 0 .98667 .52917 .52917)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.26747,
    y: 0.26747,
    width: 131.79,
    height: 78.84,
    fill: "none",
    stroke: "#392781",
    strokeMiterlimit: 10,
    strokeWidth: 0.53494
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.26679,
    y: 0.26816,
    width: 37.084,
    height: 78.839,
    fill: "#392781"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.978,
    y: 0.26816,
    width: 37.084,
    height: 78.839,
    fill: "#392781"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "submit",
    transform: "matrix(1.3171 0 0 1.3171 11.717 -3.3564)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.817,
    y: 54.894,
    width: 19.012,
    height: 5.5571,
    rx: 0.30888,
    ry: 0.30888,
    fill: "#679b34"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "upload",
    transform: "matrix(1.0127 0 0 1.0127 13.095 .011076)"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "upload-i",
    transform: "matrix(.0075316 0 0 .0075316 47.869 55.492)",
    fill: "#392781"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m798.01 421.41-169.74-169.69c-15.625-15.625-40.969-15.625-56.555 0l-169.73 169.69 56.605 56.555 101.41-101.4v423.43h79.992v-423.43l101.45 101.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m880 720v160.01h-559.99v-160.01h-80.004v160.01c0 43.98 36.012 79.992 80.004 79.992h559.99c43.992 0 80.004-36.012 80.004-79.992v-160.01z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30.473,
    y: 51.575,
    width: 13.229,
    height: 2.6458,
    rx: 0.52255,
    ry: 0.52255,
    fill: "#392781"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#392781",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.52,
    y: 55.35,
    width: 43.735,
    height: 9.3218,
    rx: 0.52255,
    ry: 0.52255,
    fill: "none",
    stopColor: "#000000",
    strokeWidth: 0.3346,
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "upload-t",
    d: "m32.873 58.396c0.37349 0.0651 1.5285-1.0171 1.1004-0.28756-0.26201 0.39763 0.12883 0.49612 0.59277 0.0594 0.42025-0.30904 1.4122-0.66649 1.436-0.18733 0.0509 1.0267 0.84292-0.23841 0.83642-0.18441-0.0175 0.14533-0.1256 0.71139 0.13616 0.66714 0.40385-0.0683 0.33557-0.98297 1.1905-0.11518 0.32224 0.32709 1.0065-0.5452 1.2939-0.64448 0.36896-0.12744 0.0693 0.65268 0.32223 0.70427 0.20078 0.041 0.50735-0.49092 0.72755-0.42601 0.30417 0.0661 0.12241 0.63378 0.52282 0.47047 0.22793-0.093 0.36589-0.27895 0.76463-0.45867 0.94-0.42366 0.73039 8e-3 0.89715 0.18595 0.75956 0.79173 1.5516-0.4734 1.5451-0.4194-0.0175 0.14533-0.1256 0.71139 0.13616 0.66714 0.40385-0.0683 0.33557-0.98297 1.1905-0.11518 0.32224 0.32709 1.0065-0.5452 1.2939-0.64448 0.36896-0.12744 0.35669 0.32086 0.32223 0.70427-0.0187 0.2084 0.45861-0.37953 0.85962-0.39648",
    fill: "none",
    opacity: 0.01,
    strokeWidth: 0.25612
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "upload-b",
    x: 32.302,
    y: 60.66,
    width: 31.353,
    height: 2.1828,
    rx: 0.40175,
    ry: 0.40175,
    fill: "url(#upload-b-grad)",
    opacity: 0.01,
    strokeWidth: 0.26458
  })))), /*#__PURE__*/React.createElement("g", {
    className: "check",
    transform: "matrix(1.0127 0 0 1.0127 13.095 .011076)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 35.723,
    y: 45.902,
    width: 18.521,
    height: 2.9104,
    rx: 0.52255,
    ry: 0.52255,
    fill: "#f00"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 30.505,
    y: 45.355,
    width: 3.8452,
    height: 3.8452,
    rx: 0.52255,
    ry: 0.52255,
    fill: "none",
    stopColor: "#000000",
    stroke: "#f00",
    strokeMiterlimit: 10,
    strokeWidth: 0.3346,
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  }), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30.473,
    y: 41.704,
    width: 31.75,
    height: 2.6458,
    rx: 0.52255,
    ry: 0.52255,
    fill: "#f00"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "check-x",
    x: 31.309,
    y: 46.16,
    width: 2.249,
    height: 2.249,
    rx: 0.20088,
    ry: 0.20088,
    fill: "#339cff",
    opacity: 0.01,
    strokeMiterlimit: 10,
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("g", {
    className: "bday",
    transform: "matrix(1.0127 0 0 1.0127 13.095 .011076)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "bday-t",
    transform: "matrix(1.3007 0 0 1.3007 -143.68 -132.36)",
    d: "m135.18 130.17c0.38633 0.35348 0.39571 0.62198 0.79612 0.45867 0.22793-0.093 0.36589-0.27895 0.76463-0.45867 0.94-0.42366 0.73039 8e-3 0.89715 0.18595 0.75956 0.79173 1.5516-0.4734 1.5451-0.4194-0.0175 0.14533-0.1256 0.71139 0.13616 0.66714 0.40385-0.0683 0.33557-0.98297 1.1905-0.11518 0.32224 0.32709 1.0065-0.5452 1.2939-0.64448 0.36896-0.12744 0.35669 0.32086 0.32223 0.70427-0.0187 0.2084 0.45861-0.37953 0.85962-0.39648 0.31527-0.0133 0.30586 0.31295 0.50815 0.34821 0.37349 0.0651 1.5285-1.0171 1.1004-0.28756-0.26201 0.39763 0.12883 0.49612 0.59277 0.0594 0.42025-0.30904 1.4122-0.66649 1.436-0.18733 0.0509 1.0267 0.84292-0.23841 0.83642-0.18441-0.0175 0.14533-0.1256 0.71139 0.13616 0.66714 0.40385-0.0683 0.33557-0.98297 1.1905-0.11518 0.32224 0.32709 1.0065-0.5452 1.2939-0.64448 0.36896-0.12744 0.35669 0.32086 0.32223 0.70427",
    fill: "none",
    opacity: 0.01,
    stroke: "#ffa900",
    strokeWidth: 0.25612
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 30.53,
    y: 34.712,
    width: 43.715,
    height: 4.4833,
    rx: 0.52255,
    ry: 0.52255,
    fill: "none",
    stroke: "#ffa900",
    strokeWidth: 0.3346
  })), /*#__PURE__*/React.createElement("text", {
    className: "bday-p",
    x: 31.810261,
    y: 38.079994,
    fill: "#ffdc99",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "3.0972px",
    letterSpacing: ".34414px",
    strokeWidth: 0.34104,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, "--/--/----")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 30.473,
    y: 31.242,
    width: 15.875,
    height: 2.6458,
    rx: 0.52255,
    ry: 0.52255,
    fill: "#ffa900"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "name",
    transform: "matrix(1.0127 0 0 1.0127 13.095 .011076)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "name-t",
    transform: "matrix(1.3007 0 0 1.3007 -143.68 -132.36)",
    d: "m135.59 122.54c0.78326-0.79273 1.5285-1.0171 1.1004-0.28756-0.26201 0.39763 0.12883 0.49612 0.59277 0.0594 0.42025-0.30904 1.4122-0.66649 1.436-0.18733 0.0509 1.0267 0.84292-0.23841 0.83642-0.18441-0.0175 0.14533-0.1256 0.71139 0.13616 0.66714 0.40385-0.0683 0.33557-0.98297 1.1905-0.11518 0.32224 0.32709 1.0065-0.5452 1.2939-0.64448 0.36896-0.12744 0.35669 0.32086 0.32223 0.70427-0.0187 0.2084 0.45861-0.37953 0.85962-0.39648 0.18352-8e-3 0.29798 0.20352 0.43565 0.48918 0.0534 0.11084 0.29113-0.35895 0.68987-0.53867 0.94-0.42366 1.5914 0.0778 1.7582 0.2557 0.75956 0.79173 1.5516-0.4734 1.5451-0.4194-0.0175 0.14533-0.1256 0.71139 0.13616 0.66714 0.40385-0.0683 0.33557-0.98297 1.1905-0.11518 0.32224 0.32709 1.0065-0.5452 1.2939-0.64448 0.36896-0.12744 0.35669 0.32086 0.32223 0.70427-0.0187 0.2084 0.45861-0.37953 0.85962-0.39648",
    fill: "none",
    opacity: 0.01,
    stroke: "#0200ff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25612
  })), /*#__PURE__*/React.createElement("rect", {
    x: 30.53,
    y: 24.388,
    width: 43.715,
    height: 4.4833,
    rx: 0.52255,
    ry: 0.52255,
    fill: "none",
    stopColor: "#000000",
    stroke: "#00f",
    strokeMiterlimit: 10,
    strokeWidth: 0.3346,
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  }), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 30.473,
    y: 20.78,
    width: 11.906,
    height: 2.6458,
    rx: 0.52255,
    ry: 0.52255,
    fill: "#0200ff"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "blurb",
    transform: "matrix(1.0127 0 0 1.0127 13.095 .011076)",
    fill: "#b7b7e1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.363,
    y: 16.306,
    width: 31.66,
    height: 2.409,
    rx: 0.52255,
    ry: 0.52255,
    stopColor: "#000000",
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.363,
    y: 13.209,
    width: 44.049,
    height: 2.409,
    rx: 0.52255,
    ry: 0.52255,
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.363,
    y: 10.111,
    width: 44.049,
    height: 2.409,
    rx: 0.52255,
    ry: 0.52255,
    stopColor: "#000000",
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "title",
    x: 54.155,
    y: 4.936,
    width: 23.983,
    height: 3.7511,
    rx: 0.52917,
    ry: 0.52917,
    fill: "#b7b7e1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandaloneForm);
export default __webpack_public_path__ + "static/media/standalone-form.e33ce55d0d79fd81882ddfdd85c4a762.svg";
export { ForwardRef as ReactComponent };